import Dashboard from '../pages/Dashboard';
import { ProjectList, ProjectCreate, ProjectDetail } from '../pages/Projects';
import { WeeklyReports, WeeklyReportHistory, ReportDetail } from '../pages/Reports';
import { UserManagement, PermissionSettings } from '../pages/Users';
import { ActivityList, ActivityDetail } from '../pages/Activities';
import { Settings } from '../pages/Settings';
import {
  RealEstateDashboard,
  PropertyList,
  BuyerList,
  BuyerDetail,
} from '../pages/RealEstate';

const routeConfig = [
  {
    path: '/',
    element: Dashboard,
    menuId: 'dashboard',
  },
  {
    path: '/real-estate',
    element: RealEstateDashboard,
    menuId: 'real-estate-dashboard',
    companyId: 'century21',
  },
  {
    path: '/real-estate/properties',
    element: PropertyList,
    menuId: 'properties-list',
    companyId: 'century21',
  },
  {
    path: '/real-estate/buyers',
    element: BuyerList,
    menuId: 'buyers-list',
    companyId: 'century21',
  },
  {
    path: '/real-estate/buyers/:id',
    element: BuyerDetail,
    menuId: 'buyers-detail',
    companyId: 'century21',
  },
  {
    path: '/projects',
    element: ProjectList,
    menuId: 'projects-list',
  },
  {
    path: '/projects/create',
    element: ProjectCreate,
    menuId: 'projects-create',
  },
  {
    path: '/projects/:id',
    element: ProjectDetail,
    menuId: 'projects-detail',
  },
  {
    path: '/reports/weekly',
    element: WeeklyReports,
    menuId: 'reports-weekly',
  },
  // {
  //   path: '/reports/project',
  //   element: ProjectReport,
  //   menuId: 'reports-project',
  // },
  // {
  //   path: '/reports/history',
  //   element: ReportHistory,
  //   menuId: 'reports-history',
  // },
  {
    path: '/reports/weekly-history',
    element: WeeklyReportHistory,
    menuId: 'reports-weekly-history',
  },
  {
    path: '/reports/:id',
    element: ReportDetail,
    menuId: 'reports-detail',
  },
  {
    path: '/users',
    element: UserManagement,
    menuId: 'users-management',
  },
  {
    path: '/users/permissions',
    element: PermissionSettings,
    menuId: 'users-permissions',
  },
  {
    path: '/settings',
    element: Settings,
    menuId: 'settings',
  },
  {
    path: '/activities',
    element: ActivityList,
    menuId: 'reports-activity',
  },
  {
    path: '/activities/:id',
    element: ActivityDetail,
    menuId: 'activities-detail',
  },
];

// Map menuId to path for navigation
export const menuToPath = {
  'dashboard': '/',
  'real-estate-dashboard': '/real-estate',
  // Parent menu items - navigate to first child
  'projects': '/projects',
  'reports': '/reports/weekly',
  'users': '/users',
  // Child menu items
  'projects-list': '/projects',
  'projects-create': '/projects/create',
  'reports-weekly': '/reports/weekly',
  'reports-weekly-history': '/reports/weekly-history',
  'reports-project': '/reports/project',
  'reports-history': '/reports/history',
  'users-management': '/users',
  'users-permissions': '/users/permissions',
  'settings': '/settings',
  'reports-activity': '/activities',
  // Real Estate menu items
  'properties': '/real-estate/properties',
  'properties-list': '/real-estate/properties',
  'buyers': '/real-estate/buyers',
  'buyers-list': '/real-estate/buyers',
  're-reports': '/real-estate',
  're-reports-property': '/real-estate',
  're-reports-buyer': '/real-estate',
};

// Map path to menuId for active state
// Note: Manual overrides needed when multiple menu items share the same path
export const pathToMenu = {
  ...Object.fromEntries(
    Object.entries(menuToPath).map(([key, value]) => [value, key])
  ),
  // Override: /real-estate should highlight Dashboard, not Reports
  '/real-estate': 'real-estate-dashboard',
};

export const resolveMenuIdFromPath = (pathname, companyId) => {
  if (pathToMenu[pathname]) {
    return pathToMenu[pathname];
  }

  if (companyId === 'century21') {
    if (pathname.startsWith('/real-estate/buyers/')) return 'buyers-list';
    if (pathname.startsWith('/real-estate/properties/')) return 'properties-list';
    if (pathname.startsWith('/real-estate')) return 'real-estate-dashboard';
  }

  if (pathname === '/projects/create') return 'projects-create';
  if (pathname.startsWith('/projects/')) return 'projects-list';

  if (pathname.startsWith('/reports/weekly/')) return 'reports-weekly';
  if (pathname.startsWith('/reports/weekly-history')) return 'reports-weekly-history';
  if (pathname.startsWith('/reports/project')) return 'reports-project';
  if (pathname.startsWith('/reports/history/')) return 'reports-history';
  if (pathname.startsWith('/reports/')) return 'reports-history';

  if (pathname.startsWith('/activities/')) return 'reports-activity';

  if (pathname.startsWith('/users/permissions')) return 'users-permissions';
  if (pathname.startsWith('/users')) return 'users-management';

  if (pathname.startsWith('/settings')) return 'settings';

  return companyId === 'century21' ? 'real-estate-dashboard' : 'dashboard';
};

export default routeConfig;
